var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreAuditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 40,
    height: 52,
    rx: 8,
    fill: "#EAF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 19h18M23 27h12M23 43l6 6 13-15",
    stroke: "#315A7C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 17,
    r: 6,
    fill: "#BD7622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreAuditIcon);
export default __webpack_public_path__ + "static/media/pre-audit-icon.9e878faa5459852f7b7e4b2ddc8641b1.svg";
export { ForwardRef as ReactComponent };